import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { JssModule, TextField } from '@sitecore-jss/sitecore-jss-angular';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'eplus-price-info',
  templateUrl: './price-info.component.html',
  styleUrls: ['./price-info.component.scss'],
  standalone: true,
  imports: [CurrencyPipe, CommonModule, JssModule],
})
export class PriceInfoComponent {
  public readonly prefixLabel = input<TextField>();
  public readonly suffixLabel = input<TextField>();
  public readonly price = input.required<number>();
  public readonly orientation = input<'row' | 'column'>('row');
  public readonly hasContentBelow = input<boolean>(false);
}
